export function distance(x1, y1, x2, y2) {
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
}

export function center(arr) {
  const total = arr.reduce((sum, currVal) => sum + currVal, 0);
  return total / arr.length;
}

export function radius(arr, xc, yc) {
  return Math.max(
    ...arr.map(el => Math.sqrt(Math.pow(xc - el.x, 2) + Math.pow(yc - el.y, 2)))
  );
}

export function nMax(array, n) {
  let arr = [...array];
  let maxNumbers = new Array(n);

  for (let i = 0; i <= n; i++) {
    let maxArr = Math.max(...arr);
    let index = arr.indexOf(maxArr);
    maxNumbers.push(maxArr);

    arr.splice(index, 0, maxArr);
  }

  return maxNumbers;
}

export function setCluster(step) {
  switch (step) {
    case 2:
      return "eu";
    case 3:
      return "se-eu";
    case 4:
      return "africa";
    case 5:
      return "arab";
    case 6:
      return "s-se-asia";
    case 7:
      return "latin";
    case 8:
      return "pacific";
    case 9:
      return "interregion";
    case 10:
      return "others";
    default:
      return null;
  }
}
